<template>
  <div class="order-report clearfix">
    <p class="tips">推荐报告中不会显示候选人的电话和邮箱</p>
    <ul class="list-info clearfix" v-if="report">
      <li>
        <span class="label">候&ensp;选&ensp;人：</span>
        <p>{{report.candidateName}}</p>
      </li>
      <li>
        <span class="label">推荐职位：</span>
        <p>{{report.positionName}}</p>
      </li>
      <li>
        <span class="label">推荐时间：</span>
        <p>{{report.createTime | date('YYYY-MM-DD HH:mm')}}</p>
      </li>
      <li>
        <span class="label">推荐顾问：</span>
        <p>{{report.hhName}}</p>
      </li>
      <li>
        <span class="label">推荐理由：</span>
        <p>{{report.reason}}</p>
      </li>
      <li>
        <span class="label">求职动机：</span>
        <p>{{report.motivation}}</p>
      </li>
      <li>
        <span class="label">目前年薪：</span>
        <p>{{report.salaryType | salaryType}} {{report.currentSalary*report.currentSalaryMonths | currency(0)}}元 ({{report.currentSalary+' X '+report.currentSalaryMonths}})</p>
      </li>
      <li v-if="report.otherWelfare">
        <span class="label">其他收入：</span>
        <p>{{report.otherWelfare}}</p>
      </li>
      <li>
        <span class="label">期望年薪：</span>
        <p>
          <template v-if="report.expectAnnualSalaryNew">
            <template v-if="report.expectAnnualSalaryNew==-1">面议</template>
            <template v-else>{{report.expectAnnualSalaryNew}}万/年 ({{report.expectSalaryType | salaryType}})</template>
          </template>
          <template v-else>{{report.expectAnnualSalaryDesc}} ({{report.expectSalaryType | salaryType}})</template>
        </p>
      </li>
      <li>
        <span class="label">离&nbsp;职&nbsp;期：</span>
        <p>{{report.dimissionTime}}</p>
      </li>
      <li>
        <span class="label">面试时间：</span>
        <p>{{report.expectInterviewTime}}</p>
      </li>
    </ul>
  </div>
</template>
<style scoped lang="scss">
  .order-report{
    background: #fff;
    min-height: 100%;
    .tips{
      background: #FFF8DE;
      height: 35px;
      line-height: 35px;
      padding: 0 15px;
      color: #333;
      font-size: 12px;
    }
    .list-info{
      line-height: 20px;
      padding: 15px;
      li{
        margin-bottom: 10px;
        font-size: 14px;
        width: 100%;
        float: left;
        .label{
          width: 70px;
          color: #666;
          display: block;
          float: left;
        }
        p{
          color: #151515;
          margin-left: 70px;
          white-space: pre-line;
        }
      }
    }
  }
</style>
<script>
import { getCandidateReport } from '@/api/order';
export default {
  data(){
    return{
      id: this.$route.params.id,
      report: null
    };
  },
  components: {
  },
  methods: {
    getDetail(){
      getCandidateReport(this.id).then(res => {
        if (res && res.data) {
          this.report = res.data || null;
        }
      }).catch(err=>{});
    }
  },
  created() {
    this.getDetail();
  }
};
</script>
